import React from "react";
import "./index.scss";

const classPrefix = "yfm-product-detail-picture-skeleton";

const ProductPictureSkeleton: React.FC = () => {
  return (
    <div className={`${classPrefix} yfm-is-skeleton`}>
      <div className={`${classPrefix}__indicator`}></div>
    </div>
  );
};

export default ProductPictureSkeleton;
